export const sidebarContent: {
  name: string;
  link: string;
  icon?: string;
  nestedLink: { name: string; link: string }[] | null;
}[] = [
  {
    name: 'Home',
    icon: 'home',
    link: '',
    nestedLink: null,
  },
  {
    name: 'Reports',
    icon: 'reports',
    link: '',
    nestedLink: null,
  },
  {
    name: 'Tasks',
    icon: 'tasks',
    link: '',
    nestedLink: null,
  },
  {
    name: 'Projects',
    icon: 'projects',
    link: '',
    nestedLink: null,
  },
  {
    name: 'Team',
    icon: 'team',
    link: '',
    nestedLink: null,
  },
  {
    name: 'Messages',
    icon: 'messages',
    link: '',
    nestedLink: null,
  },
  {
    name: 'Companies',
    link: 'companies/all',
    icon: 'companies',
    nestedLink: [
      { name: 'Active', link: 'companies/active' },
      { name: 'Inactive', link: 'companies/inactive' },
      { name: 'Pending', link: 'companies/pending' },
    ],
  },
  {
    name: 'Settings',
    link: '',
    icon: 'settings',
    nestedLink: null,
  },
  {
    name: 'My Account',
    link: '',
    icon: 'my-account',
    nestedLink: null,
  },
];
